<template>
  <div class="nurseBindingUserInfoList">
    <div class="list">
      <div
        class="item"
        v-for="(item,index) in nurseBindingUserInfoList"
        :key="index"
      >
        <div class="left">
          <svg :id="'barcode'+item.barCode"></svg>
        </div>
        <div
          class="del"
          @click="del(index)"
        >删除</div>
      </div>
    </div>
    <div class="btnBox">
      <div
        class="btn add"
        @click="add()"
      >继续添加</div>
      <div
        class="btn save"
        @click="save"
      >提交信息</div>
    </div>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
export default {
  data() {
    return {
      nurseBindingUserInfoList: []
    };
  },
  created() {
    if (!localStorage.getItem("systemUserInfo")) {
      localStorage.setItem("redirect", location.hash.slice(1));
      this.$router.replace({
        name: "nurseLogin"
      });
    }
  },
  methods: {
    add(subOrderNo) {
      this.$router.push({
        name: "nurseSweepCodeBinding"
      });
    },
    save() {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        let list = JSON.parse(localStorage.getItem("nurseBindingUserInfoList"));
        let newList = [];
        let employeeId = JSON.parse(localStorage.getItem("systemUserInfo")).id;
        // let employeeId = '1268068541692510210'; 测试
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          newList.push({
            barCode: item.barCode,
            employeeId: employeeId,
            userId: item.userId
          });
        }
        this.$loading("提交中");
        this.$http
          .post(
            `/sfOrderRecordBarCode/saveModel`,
            { employeeId: employeeId, sfOrderRecordBarCodeList: newList },
            {
              qs: "no"
            }
          )
          .then(res => {
            if (res.data.code == 200) {
              localStorage.removeItem("nurseBindingUserInfoList");
              this.$tootsSuccess("保存成功");
              setTimeout(() => {
                this.$router.replace({
                  name: "nurseSweepCodeBinding"
                });
              }, 1500);
            } else this.$toots(res.data.msg);
          })
          .catch(err => {
            this.$toots("系统正在升级，请稍后");
          });
      }
    },
    del(index) {
      let list = this.nurseBindingUserInfoList;
      list.splice(index, 1);
      if (list.length == 0) {
        localStorage.removeItem("nurseBindingUserInfoList");
        this.$router.replace({
          name: "nurseSweepCodeBinding"
        });
        return;
      }
      this.nurseBindingUserInfoList = list;
      localStorage.setItem("nurseBindingUserInfoList", JSON.stringify(list));
    }
  },
  mounted() {
    this.nurseBindingUserInfoList = JSON.parse(
      localStorage.getItem("nurseBindingUserInfoList")
    );
    let list = this.nurseBindingUserInfoList;
    setTimeout(() => {
      for (let i = 0; i < list.length; i++) {
        JsBarcode("#barcode" + list[i].barCode, list[i].barCode, {
          text: list[i].barCode,
          width: 1.8,
          height: 60
        });
      }
    }, 200);
  }
};
</script>

<style lang='less' scoped>
.nurseBindingUserInfoList {
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .list {
    flex: 1;
    padding: 30px;
    .item::first-child {
      margin-top: 0;
    }
    .item {
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px;
      border-radius: 10px;
      margin-top: 20px;
      .left {
        // width: 405px;
        flex: 1;
        // img {
        //   width: 405px;
        //   height: 144px;
        // }
        .barcode {
          text-align: center;
          font-size: 36px;
          letter-spacing: 13px;
        }
      }
      .del {
        width: 180px;
        height: 76px;
        line-height: 76px;
        text-align: center;
        font-size: 34px;
        color: #1968a8;
        border-radius: 10px;
        border: 1PX solid #1968a8;
      }
    }
  }
  .btnBox {
    height: 260px;
    margin-top: 30px;
  }
  .btn {
    width: 660px;
    margin: 0 auto;
    height: 80px;
    line-height: 80px;
    border-radius: 80px;
    text-align: center;
    font-size: 34px;
  }
  .save {
    margin-top: 40px;
    color: #fff;
    background-color: #1968a8;
  }
  .add {
    color: #1968a8;
    border: 1PX solid #1968a8;
  }
}
</style>
